import { Checkbox, Collapsible, Select } from "@tredespace/ui/widgets";
import type { JSX } from "react";
import { setDiag, setGuard, setTerrain } from "../../state/generator/generator.actions.ts";
import { generatorState } from "../../state/generator/generator.state.ts";
import { DeckingSection } from "./DeckingSection.tsx";
import { Field } from "./Field.tsx";
import { TERRAINS, toTerrain } from "./generatorOptions.ts";
import { LayoutSection } from "./LayoutSection.tsx";

/** Settings for the "80 %" generator; the Generate button lives in the ribbon. */
export function GeneratorPanel(): JSX.Element {
  const { guard, diag, terrain } = generatorState.use();

  return (
    <div className="flex h-full flex-col gap-2 overflow-y-auto p-3">
      <LayoutSection />
      <DeckingSection />

      <Collapsible title="Safety" defaultOpen>
        <div className="flex flex-col gap-1.5">
          <Checkbox
            checked={guard}
            onChange={setGuard}
            label="Guardrails + toe boards on open edges"
            hint="generator only"
          />
          <Checkbox
            checked={diag}
            onChange={setDiag}
            label="Diagonals"
            hint="end bays + every 5th"
            info="RISE C900677 requires vertical diagonals in the end bays and at least every fifth bay."
          />
        </div>
      </Collapsible>

      <Collapsible title="Ground">
        <Field label="Terrain">
          <Select
            value={terrain}
            onChange={(value) => value && setTerrain(toTerrain(value))}
            options={TERRAINS.map((entry) => ({ value: entry.value, label: entry.label }))}
          />
        </Field>
        <p className="mt-2 text-xs leading-relaxed text-slate-400">
          Standards land on the surface you click. A roof or deck carries the standard directly; a wall places
          it 250 mm out. The base jack is then solved to 55–570 mm against the shared 500 mm level grid.
        </p>
      </Collapsible>
    </div>
  );
}
